<template>
  <CRow>
    <CCol sm="6" lg="3">
      <CWidgetDropdown color="gradient-primary" :header="this.totalClients" text="Πελάτες" class="pb-4">
        <template #default>
          <CDropdown
            class="float-right"
            color="transparent p-0"
            placement="bottom-end"
          >
            <template #toggler-content>
              <CIcon name="cil-settings"/>
            </template>
            <CDropdownItem @click="$router.push({ path: '/clients' })">Λίστα πελατών</CDropdownItem>
            <CDropdownItem @click="$router.push({ path: '/clients/create' })">Καταχώρηση πελατών</CDropdownItem>
          </CDropdown>
        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol sm="6" lg="3">
      <CWidgetDropdown color="gradient-info" :header="this.totalServices" text="Υπηρεσίες" class="pb-4">
        <template #default>
          <CDropdown
            class="float-right"
            color="transparent p-0"
            placement="bottom-end"
          >
            <template #toggler-content>
              <CIcon name="cil-settings"/>
            </template>
            <CDropdownItem @click="$router.push({ path: '/services' })">Λίστα υπηρεσιών</CDropdownItem>
            <CDropdownItem @click="$router.push({ path: '/services/create' })">Καταχώρηση υπηρεσιών</CDropdownItem>
          </CDropdown>
        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol sm="6" lg="3">
      <CWidgetDropdown
        color="gradient-warning"
        :header="this.totalSubcontractors" 
        text="Υπερβολάβοι"
        class="pb-4"
      >
        <template #default>
          <CDropdown
            class="float-right"
            color="transparent p-0"
            placement="bottom-end"
          >
            <template #toggler-content>
              <CIcon name="cil-settings"/>
            </template>
            <CDropdownItem @click="$router.push({ path: '/subcontractors' })">Λίστα υπεργολάβων</CDropdownItem>
            <CDropdownItem @click="$router.push({ path: '/subcontractors/create' })">Καταχώρηση υπεργολάβων</CDropdownItem>
          </CDropdown>
        </template>
      </CWidgetDropdown>
    </CCol>
    <CCol sm="6" lg="3">
      <CWidgetDropdown
        color="gradient-danger"
        :header="this.totalConsultantsSellers" 
        text="Σύμβουλοι"
        class="pb-4"
      >
        <template #default>
          <CDropdown
            class="float-right"
            color="transparent p-0"
            placement="bottom-end"
          >
            <template #toggler-content>
             <CIcon name="cil-settings"/>
            </template>
            <CDropdownItem @click="$router.push({ path: '/consultantSellers' })">Λίστα συμβούλων - πωλητών</CDropdownItem>
            <CDropdownItem @click="$router.push({ path: '/consultantSellers/create' })">Καταχώρηση συμβούλων - πωλητών</CDropdownItem>
          </CDropdown>
        </template>
      </CWidgetDropdown>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

export default {
  name: 'WidgetsDashboardQuickMenu',
  data () {
    return {
      totalClients: '0',
      totalServices: '0',
      totalSubcontractors: '0',
      totalInspectors: '0',
      totalConsultantsSellers: '0'
    }
  },
  methods: {
    getQuickMenuItems() {
      let self = this;
      
      axios.get('/api/services/getClientsServicesSubcontractorsConsultantsDashboard?token=' + localStorage.getItem("api_token"))
      .then(response => {
        self.totalClients = response.data.totalClients.toString();
        self.totalServices = response.data.totalServices.toString();
        self.totalSubcontractors = response.data.totalSubcontractors.toString();
        self.totalConsultantsSellers = response.data.totalConsultantsSellers.toString();
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    }
  },
  mounted: function(){
    this.getQuickMenuItems();
  }
}
</script>
